export default __webpack_public_path__ + "static/racing-8e33614c6279c2cd5e66525fd089fed0.png";